export type EventProperties = Record<
  string,
  number | string | boolean | number[] | null
>;

export interface AnalyticsEvent {
  name: string;
  sentAt: Date;
  properties: EventProperties;
}

export enum EventNames {
  signupStarted = 'signupStarted',
  signupLogin = 'signupLogin',
  signupPhoneNumberEntered = 'signupPhoneNumberEntered',
  signupLoginError = 'signupLoginError',
  signupPasswordError = 'signupPasswordError',
  signupPasswordComplete = 'signupPasswordComplete',
  signupUserDetails = 'signupUserDetails',
  signupCompleted = 'signupCompleted',
  menuBarSelected = 'menuBarSelected',
  profileScreenLogout = 'profileScreenLogout',
  trainingTrainingSelected = 'trainingTrainingSelected',
  trainingQuizStarted = 'trainingQuizStarted',
  trainingQuizIncomplete = 'trainingQuizIncomplete',
  trainingQuizComplete = 'trainingQuizComplete',
  trainingRetakePopup = 'trainingRetakePopup',
  trainingCourseSelected = 'trainingCourseSelected',
  lessonLessonStarted = 'lessonLessonStarted',
  fluidLessonStarted = 'fluidLessonStarted',
  lessonLessonCompleted = 'lessonLessonCompleted',
  fluidLessonCompleted = 'fluidLessonCompleted',
  fluidLessonBackClicked = 'fluidLessonBackClicked',
  lessonBackClicked = 'lessonBackClicked',
  lessonLessonSection = 'lessonLessonSection',
  fluidLessonSection = 'fluidLessonSection',
  refreshDataRefreshDataClicked = 'refreshDataRefreshDataClicked',
  dataLoadingDataLoadingFailed = 'dataLoadingDataLoadingFailed',
  retryDataRetryDataClicked = 'retryDataRetryDataClicked',
  syncDataSyncDataFailedError = 'syncDataSyncDataFailedError',
  resetPasswordForgetPasswordClicked = 'resetPasswordForgetPasswordClicked',
  resetPasswordOTPVerified = 'resetPasswordOTPVerified',
  resetPasswordResendOTPClicked = 'resetPasswordResendOTPClicked',
  resetPasswordChoosePasswordNextClicked = 'resetPasswordChoosePasswordNextClicked',
  resetPasswordAccountVerificationNextClicked = 'resetPasswordAccountVerificationNextClicked',
  noInternetNoInternetPopup = 'noInternetNoInternetPopup',
  recordsFailedToSync = 'recordsFailedToSync',
  pushSyncPartialFailure = 'pushSyncPartialFailure',
  chatWidgetClicked = 'chatWidgetClicked',
  lessonTranslateClicked = 'lessonTranslateClicked',
  lessonTranslateError = 'lessonTranslateError',
  userProfileDelete = 'userProfileDelete',
  dashboardAddClassClicked = 'dashboardAddClassClicked',
  dashboardGradeSelected = 'dashboardGradeSelected',
  dashboardSectionSelected = 'dashboardSectionSelected',
  dashboardShiftSelected = 'dashboardShiftSelected',
  dashboardSubjectSelected = 'dashboardSubjectSelected',
  dashboardDaySelected = 'dashboardDaySelected',
  dashboardClassSelected = 'dashboardClassSelected',
  trainingDownloadClicked = 'trainingDownloadClicked',
  trainingDownloadStarted = 'trainingDownloadStarted',
  trainingDownloadComplete = 'trainingDownloadComplete',
  trainingRetryDownload = 'trainingRetryDownload',
  trainingDownloadError = 'trainingDownloadError',
  trainingDownloadVideoPlayed = 'trainingDownloadVideoPlayed',
  trainingDownloadDeleted = 'trainingDownloadDeleted',
  trainingDownloadDeleteAll = 'trainingDownloadDeleteAll',
  courseDownloadClicked = 'courseDownloadClicked',
  courseDownloadDeleted = 'courseDownloadDeleted',
  lessonDownloadClicked = 'lessonDownloadClicked',
  lessonDownload = 'lessonDownload',
  lessonDownloadDeleted = 'lessonDownloadDeleted',
  lessonDownloadComplete = 'lessonDownloadComplete',
  lessonDownloadError = 'lessonDownloadError',
  lessonRetryDownload = 'lessonRetryDownload',
  lessonDownloadCanceled = 'lessonDownloadCanceled',
  chapterDownload = 'chapterDownload',
  chapterDownloadDeleted = 'chapterDownloadDeleted',
  chapterRetryDownload = 'chapterRetryDownload',
  timetableEditClassClicked = 'timetableEditClassClicked',
  timetableEditDaysSaved = 'timetableEditDaysSaved',
  timetableDeleteClass = 'timetableDeleteClass',
  resultsClassSelected = 'resultsClassSelected',
  resultsAssessmentSelected = 'resultsAssessmentSelected',
  resultsStudentClicked = 'resultsStudentClicked',
  reportCardStudentClicked = 'reportCardStudentClicked',
  resultsInputsSaved = 'resultsInputsSaved',
  reportCardPrintClicked = 'reportCardPrintClicked',
  resultsDashboardClicked = 'resultsDashboardClicked',
  reportCardBackClicked = 'reportCardBackClicked',
  studentListAccessed = 'studentListAccessed',
  studentListAddStudent = 'studentListAddStudent',
  studentListProfileOpened = 'studentListProfileOpened',
  studentListDeleteStudent = 'studentListDeleteStudent',
  studentListEditInfo = 'studentListEditInfo',
  studentListMarkAsVerified = 'studentListMarkAsVerified',
  trainingSubjectCourseClicked = 'trainingSubjectCourseClicked',
  examGeneratorCreateExam = 'examGeneratorCreateExam',
  examGeneratorClassSelected = 'examGeneratorClassSelected',
  examGeneratorAssessmentTypeSelected = 'examGeneratorAssessmentTypeSelected',
  examGeneratorFlnTypeSelected = 'examGeneratorFlnTypeSelected',
  examGeneratorAssessmentSelected = 'examGeneratorAssessmentSelected',
  examGeneratorTypeSelected = 'examGeneratorTypeSelected',
  examGeneratorhistroyOpenAssessments = 'examGeneratorhistroyOpenAssessments',
  examGeneratorQuestionsSelected = 'examGeneratorQuestionsSelected',
  createExamLoadQuestions = 'createExamLoadQuestions',
  examGeneratorAddToExam = 'examGeneratorAddToExam',
  examGeneratorGenerateExam = 'examGeneratorGenerateExam',
  examGeneratorDownloadAndPrint = 'examGeneratorDownloadAndPrint',
  examGeneratorhistoryExamEdit = 'examGeneratorhistoryExamEdit',
  examGeneratorAddAnswerLines = 'examGeneratorAddAnswerLines',
  examGeneratorShowAnswersAndMarkingScheme = 'examGeneratorShowAnswersAndMarkingScheme',
  examGeneratorEditChapter = 'examGeneratorEditChapter',
  examGeneratorDeleteExam = 'examGeneratorDeleteExam',
  ugEgQuestionSourceSelected = 'ugEgQuestionSourceSelected',
  ugEgQuestionFormatsSelected = 'ugEgQuestionFormatsSelected',
  ugEgExamGenerated = 'ugEgExamGenerated',
  ugEgPaperDownloadClicked = 'ugEgPaperDownloadClicked',
  ugEgExamEditClicked = 'ugEgExamEditClicked',
  ugEgExamCompleted = 'ugEgExamCompleted',
  examCheckerClassSelected = 'examCheckerClassSelected',
  examCheckerAssessmentSelected = 'examCheckerAssessmentSelected',
  examCheckerExamSelected = 'examCheckerExamSelected',
  examCheckerInstructionScreen = 'examCheckerInstructionScreen',
  examCheckerTakePicture = 'examCheckerTakePicture',
  examCheckerSelectStudent = 'examCheckerSelectStudent',
  examCheckerAddStudent = 'examCheckerAddStudent',
  examCheckerWalkthroughPopup = 'examCheckerWalkthroughPopup',
  examCheckerDeletePictureDialog = 'examCheckerDeletePictureDialog',
  examCheckerDeleteStudent = 'examCheckerDeleteStudent',
  examCheckerRetakePicture = 'examCheckerRetakePicture',
  examCheckerStudentResultClicked = 'examCheckerStudentResultClicked',
  examCheckerUploadPicture = 'examCheckerUploadPicture',
  examCheckerConfirmClicked = 'examCheckerConfirmClicked',
  examCheckerDeleteClicked = 'examCheckerDeleteClicked',
  examCheckerDeleteDialog = 'examCheckerDeleteDialog',
  examCheckerImageClicked = 'examCheckerImageClicked',
  parentInvitePrompt = 'parentInvitePrompt',
  inviteParentsDialogClicked = 'inviteParentsDialogClicked',
  inviteParentsClicked = 'inviteParentsClicked',
  confirmSelectionClicked = 'confirmSelectionClicked',
  sendInviteClicked = 'sendInviteClicked',
  copyLinkClicked = 'copyLinkClicked',
  helpClicked = 'helpClicked',
  pushNotificationAllowed = 'pushNotificationAllowed',
  pushNotificationAllowedAndroid = 'pushNotificationAllowedAndroid',
  pushNotificationDismissed = 'pushNotificationDismissed',
  pushNotificationDismissedAndroid = 'pushNotificationDismissedAndroid',
  pushNotificationClicked = 'pushNotificationClicked',
  pushNotificationPopupReceived = 'pushNotificationPopupReceived',
  resultsNotificationClicked = 'resultsNotificationClicked',
  resultsNotificationDismissed = 'resultNotificationDismissed',
  parentAppYesClick = 'parentAppYesClick',
  parentAppNoClick = 'parentAppNoClick',
  parentAppChildSelected = 'parentAppChildSelected',
  parentAppResultCardClick = 'parentAppResultCardClick',
  parentAppPracticeTestClick = 'parentAppPracticeTestClick',
  parentAppSwitchChildCardClick = 'parentAppSwitchChildCardClick',
  parentAppDeepLinkOpened = 'parentAppDeepLinkOpened',
  parentAppPhoneNumberCheck = 'parentAppPhoneNumberCheck',
  regionSelected = 'regionSelected',
  changeRegionClicked = 'changeRegionClicked',
  UIError = 'UIError',
  resultsSubjectselected = 'resultsSubjectselected',
  resultsQuestionTypeSelected = 'resultsQuestionTypeSelected',
  resultsEditClicked = 'resultsEditClicked',
  resultsUpdateClicked = 'resultsUpdateClicked',
  resultsInsightsClicked = 'resultsInsightsClicked',
  resultsMistakeCategoryClicked = 'resultsMistakeCategoryClicked',
  notificationIconClicked = 'notificationIconClicked',
  notificationCardClicked = 'notificationCardClicked',
  notificationOpenFailed = 'notificationOpenFailed',
  trainingLevelClicked = 'trainingLevelClicked',
  examCheckerExamGeneratorClicked = 'examCheckerExamGeneratorClicked',
  examCheckerStudentListClicked = 'examCheckerStudentListClicked',
  examGeneratorShareExam = 'examGeneratorShareExam',
  studentsManageClassSelected = 'studentsManageClassSelected',
  studentsManageClassTeacher = 'studentsManageClassTeacher',
  studentsManageDeleteFail = 'studentsManageDeleteFail',
  studentsManageDeleteOther = 'studentsManageDeleteOther',
  communityNewPost = 'communityNewPost',
  communityToggleLike = 'communityToggleLike',
  communityNewComment = 'communityNewComment',
  communityVotePoll = 'communityVotePoll',
  communityClosePoll = 'communityClosePoll',
  communityLoadMorePosts = 'communityLoadMorePosts',
  communitySelectedPostTab = 'communitySelectedPostTab',
  communityShowAllPosts = 'communityShowAllPosts',
  communityNotificationIconClicked = 'communityNotificationIconClicked',
  communityNotificationClicked = 'communityNotificationClicked',
  communityNotificationMarkAllAsRead = 'communityNotificationMarkAllAsRead',
  communityNotificationSelectedTab = 'communityNotificationSelectedTab',
  sedFormRegisterClick = 'sedFormRegisterClick',
  sedOtpGenerated = 'sedOtpGenerated',
  sedResendOtpClicked = 'sedResendOtpClicked',
  sedRegistrationCompleted = 'sedRegistrationCompleted',
  sedUserRegistered = 'sedUserRegistered',
  sedRegisterBackClicked = 'sedRegisterBackClicked',
  sedRegisterButtonClicked = 'sedRegisterButtonClicked',
  sedLoginButtonClicked = 'sedLoginButtonClicked',
  visitSchedulerCreateSchedule = 'visitSchedulerCreateSchedule',
  visitSchedulerScheduleDatesSelected = 'visitSchedulerScheduleDatesSelected',
  visitSchedulerSaveSchedule = 'visitSchedulerSaveSchedule',
  visitSchedulerUpdateCoach = 'visitSchedulerUpdateCoach',
  visitSchedulerScheduleDatesEdited = 'visitSchedulerScheduleDatesEdited',
  inviteAccepted = 'inviteAccepted',
  inviteCancelled = 'inviteCancelled',
  addProfileButtonClicked = 'addProfileButtonClicked',
  addAnotherProfile = 'addAnotherProfile',
  accountCreated = 'accountCreated',
  profileSwitched = 'profileSwitched',
  profileSelected = 'profileSelected',
  profileEditClicked = 'profileEditClicked',
  schoolProfileClicked = 'schoolProfileClicked',
  coachScheduleBeginObservation = 'coachScheduleBeginObservation',
  coachScheduleObservationSubmitted = 'coachScheduleObservationSubmitted',
  coachScheduleSchoolSelected = 'coachScheduleSchoolSelected',
  coachScheduleTeacherPlan = 'coachScheduleTeacherPlan',
  coachScheduleObservationOpen = 'coachScheduleObservationOpen',
  coachScheduleVisitReschedule = 'coachScheduleVisitReschedule',
  coachScheduleVisitDelete = 'coachScheduleVisitDelete',
  planObservation = 'planObservation',
  startObservation = 'startObservation',
  flnTabSelected = 'flnTabSelected',
  flnDownloadClicked = 'flnDownloadClicked',
  flnTaskSelected = 'flnTaskSelected',
  flnAudioPlayed = 'flnAudioPlayed',
  flnStudentCategoryChanged = 'flnStudentCategoryChanged',
  flnStudentAdded = 'flnStudentAdded',
  manualResultsStudentAdded = 'manualResultsStudentAdded',
  trainingAttemptExamClicked = 'trainingAttemptExamClicked',
  trainingQuizFailed = 'trainingQuizFailed',
  trainingQuizPassed = 'trainingQuizPassed',
  trainingQuizExit = 'trainingQuizExit',
  levelUnlocked = 'levelUnlocked',
  trainingLevelExamPassed = 'trainingLevelExamPassed',
  trainingExamLevelFailed = 'trainingExamLevelFailed',
  trainingExamExit = 'trainingExamExit',
  trainingStartExamClicked = 'trainingStartExamClicked',
  trainingExamLevelPassed = 'trainingExamLevelPassed',
  trainingCertificateDownload = 'trainingCertificateDownload',
  LevelExamIncomplete = 'LevelExamIncomplete',
  trainingDiagnosticStarted = 'trainingDiagnosticStarted',
  trainingDiagnosticCompleted = 'trainingDiagnosticCompleted',
  trainingDiagnosticIncomplete = 'trainingDiagnosticIncomplete',
  userGenLessonPlanGenerate = 'userGenLessonPlanGenerate',
  userGenLessonPlanViewAll = 'userGenLessonPlanViewAll',
  userGenLessonPlanCardClick = 'userGenLessonPlanCardClick',
  userGenLessonPlanEdit = 'userGenLessonPlanEdit',
  userGenLessonPlanSave = 'userGenLessonPlanSave',
  userGenLessonPlanComplete = 'userGenLessonPlanComplete',
  userGenLessonPlanGenerateNew = 'userGenLessonPlanGenerateNew',
  userGenLessonPlanBackClick = 'userGenLessonPlanBackClick',
  userGenLessonPlanWeeklyLimitReached = 'userGenLessonPlanWeeklyLimitReached',
  userGenLessonPlanMaxWeeklyLimitReached = 'userGenLessonPlanMaxWeeklyLimitReached',
  userGenLessonPlanGenerationBackendError = 'userGenLessonPlanGenerationBackendError',
  userGenLessonPlanRevisionSelected = 'userGenLessonPlanRevisionSelected',
  userGenLessonPlanTabSelected = 'userGenLessonPlanTabSelected',
  userGenLessonPlanAiEditSubmit = 'userGenLessonPlanAiEditSubmit',
  userGenLessonPlanAiEditSuccess = 'userGenLessonPlanAiEditSuccess',
  userGenLessonPlanAiEditError = 'userGenLessonPlanAiEditError',
  userGenLessonPlanViewHistory = 'userGenLessonPlanViewHistory',
  observationFeedbackAIGenerate = 'observationFeedbackAIGenerate',
  observationFeedbackManualWrite = 'observationFeedbackManualWrite',
  observationFeedbackEdit = 'observationFeedbackEdit',
  observationFeedbackSave = 'observationFeedbackSave',
  erpTransferProfileMenuOpened = 'erpTransferProfileMenuOpened',
  erpTransferProfileOptionSelected = 'erpTransferProfileOptionSelected',
  erpTransferProfileSubmitted = 'erpTransferProfileSubmitted',
  resultsManualOptionClicked = 'resultsManualOptionClicked',
  resultsAICheckerOptionClicked = 'resultsAICheckerOptionClicked',
  resultEditStudentResultsSaved = 'resultEditStudentResultsSaved',
  resultEditStudentResultViewed = 'resultEditStudentResultViewed',
  digitalCoachEntry = 'digitalCoachEntry',
  digitalCoachRecordingStarted = 'digitalCoachRecordingStarted',
  digitalCoachRecordingSubmitted = 'digitalCoachRecordingSubmitted',
  digitalCoachFeedbackSeen = 'digitalCoachFeedbackSeen',
  digitalCoachOnboarding = 'digitalCoachOnboarding',
  digitalCoachOnboardingVideo = 'digitalCoachOnboardingVideo',
  digitalCoachOnboardingClose = 'digitalCoachOnboardingClose',
  classInsightClicked = 'classInsightClicked',
  digitalCoachNotificationClicked = 'digitalCoachNotificationClicked',
  externalLessonPlanOpened = 'externalLessonPlanOpened',
  externalLessonPlanCompleted = 'externalLessonPlanCompleted',
  observationSubmitted = 'observationSubmitted',
}
